export const LanguageLevels = {
    Fluent: { Key: "Fluent", Ratio: 0.8 },
    Intermediate: { Key: "Intermediate", Ratio: 0.5 },
    Basic: { Key: "Basic", Ratio: 0.2 },
    Beginner: { Key: "Beginner", Ratio: 0.0 }
};
